export const bookCovers = {
  'japanese-candlestick': 'https://covers.openlibrary.org/b/isbn/9780735201811-L.jpg',
  'book-candlestick': 'https://covers.openlibrary.org/b/isbn/9780735201811-L.jpg',
  'technical-analysis': 'https://covers.openlibrary.org/b/isbn/9780735200661-L.jpg',
  'book-technical-analysis': 'https://covers.openlibrary.org/b/isbn/9780735200661-L.jpg',
  'trading-psychology': 'https://covers.openlibrary.org/b/isbn/9780735201446-L.jpg',
  'book-trading-psychology': 'https://covers.openlibrary.org/b/isbn/9780735201446-L.jpg',
  'intelligent-investor': 'https://covers.openlibrary.org/b/isbn/9780060555665-L.jpg',
  'market-wizards': 'https://covers.openlibrary.org/b/isbn/9780887306105-L.jpg',
  'reminiscences-stock-operator': 'https://covers.openlibrary.org/b/isbn/9780471770886-L.jpg',
  'book-reminiscences': 'https://covers.openlibrary.org/b/isbn/9780471770886-L.jpg',
  'price-action': 'https://covers.openlibrary.org/b/isbn/9781118066515-L.jpg',
  'market-profile': 'https://covers.openlibrary.org/b/isbn/9780471731733-L.jpg',
  'turtle-trading': 'https://covers.openlibrary.org/b/isbn/9780071486644-L.jpg',
  'book-turtle-trading': 'https://covers.openlibrary.org/b/isbn/9780071486644-L.jpg',
  'bitcoin-standard': 'https://covers.openlibrary.org/b/isbn/9781119473862-L.jpg',
  'book-bitcoin-standard': 'https://covers.openlibrary.org/b/isbn/9781119473862-L.jpg',
};

export const DEFAULT_BOOK_COVER = bookCovers['japanese-candlestick'];

export function getBookCover(bookOrId) {
  const id = typeof bookOrId === 'string' ? bookOrId : bookOrId?.id;
  return bookCovers[id] || DEFAULT_BOOK_COVER;
}
